import { Chakra } from "@airhelp/react-ui-components";
import NextLink from "next/link";
import type { SideMenuItemProps } from "./SideMenuItem.d";

const { ListItem, Link } = Chakra;

const SideMenuItem = ({ heading, isActive }: SideMenuItemProps) => {
  const { current: { id, textContent } = {} } = heading;

  return (
    <ListItem>
      <NextLink href={`#${id}`} passHref>
        <Link
          position="relative"
          color={isActive ? "primary.700" : "primary.900"}
          fontWeight={isActive ? "medium" : "regular"}
          _hover={{ textDecoration: "none" }}
          _before={
            isActive
              ? {
                  content: `""`,
                  position: "absolute",
                  width: "7px",
                  height: "7px",
                  background: "primary.500",
                  borderRadius: "full",
                  left: "-16px",
                  top: "6px",
                }
              : null
          }
          _focus={{
            outline: "none",
          }}
          _visited={{}}
        >
          {textContent}
        </Link>
      </NextLink>
    </ListItem>
  );
};

export default SideMenuItem;
